<template>
  <div class="animated fadeIn">
    <DateModal
      modalID="overall"
      :fetchData="fetchData"
      :dateFrom="dateFrom"
      :dateTo="dateTo"
      @date-picker-modal-emit="onDatePickerModalEmit"
    ></DateModal>
    <b-row>
      <b-col
        lg="12"
        style="margin-bottom:15px; border-bottom:2px solid black; padding-bottom:15px"
      >
        <span>Choose Data: </span>
        <b-form-select
          v-model="link"
          :options="options"
          style="width:200px; color: white; background: #343b41;"
          value-field="item"
          @change="(loading = true), fetchData()"
          text-field="name"
        ></b-form-select>
        <b-button
          @click="modalDateEvent('overall')"
          class
          style="height: 26px; width: 26px; float:right"
          variant="transparent p-0"
        >
          <i class="icon-calendar" style="color: #20a8d8;"></i>
        </b-button>
        <b-button
              @click="setLastMonth"
            style="min-width: 100px; height: 26px; padding: 0 10px; margin-right:10px; float:right;"
            variant="outline-primary"
          >
            Last 30 days
        </b-button>
        <span
          style="float:right; line-height:30px; margin-right:20px; color:rgb(32, 168, 216)"
        >
          {{ from() ? from() : dateFrom }} <b>|</b> {{ to() ? to() : dateTo }}
        </span>
      </b-col>
      <b-col lg="12">
        <b-card-header
          v-if="!loading"
          style="border-bottom:0px !important; font-size:1.5em"
        >
          <span style="padding:5px;">Total Records:</span>
          <b>{{
            total
          }}</b>
          <b-button
            class="download-button"
            variant="primary"
            size="xl"
            @click="downloadExcel()"
          >
            <LoadingCard
              v-if="loading2019"
              width="20px"
              height="20px"
            ></LoadingCard>
            <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>Download
          </b-button>
          <b-form-group
            style="display:inline-block; float:right; margin-bottom:15px"
          >
            <b-input-group size="xl">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-card-header>
        <div v-if="loading" class="centered_container">
          <LoadingCard></LoadingCard>
        </div>
        <b-table
          v-else
          :filter="filter"
          responsive="sm"
          :items="data"
          :fields="fields"
          style="background:#343b41; border:0px 1px solid black;"
        >
        </b-table>
        <div v-if="message !== ''" class="centered_container">
          <p>{{ message }}</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "../Table.vue";
import Datepicker from "vuejs-datepicker";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import DateModal from "../../../components/shared/DateModal.vue";
import { modelStore, setIsFetching  } from '@/stores/modelStore';

export default {
  name: "OverallData",
  components: { cTable, Datepicker, LoadingCard, DateModal },
  data: () => {
    return {
      excelDownload: "",
      loading2019: false,
      options: [
        { name: "Shipped Search", item: "shippedsearch" }
      ],
      loadingExcel: false,
      productGroupParam: "",
      modelParam: "",
      link: "shippedsearch",
      filter: null,
      dateFrom: "",
      dateTo: "",
      modalDate: false,
      newharid: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      message: "",
      fields: [
        { key: "fnsid", label: "FNS ID", sortable: true },
        { key: "locat", label: "Location" },
        { key: "sernm", label: "Serial#" },
        {
          key: "pMake",
          label: "Manufacturer",
          sortable: true,
          style: "width: 250px"
        },
        { key: "pMode", label: "Model" },
        {
          key: "compl",
          label: "Complaint",
          sortable: true,
          tdClass: "complaintClass"
        },
        { key: "loctn", label: "Status", sortable: true }
      ],
      requestId: 0
    };
  },
  methods: {
    setDefaultColumns(schemaName) {
      this.fields = [

        { key: "receiveDate", label: "Receive Date" },
        { key: "fnsid", label: "FNS ID" },
        { key: "prodFam", label: "Product Family" },
        { key: "sernm", label: "Serial Number" },
        { key: "ra", label: "RA" },
        { key: "war", label: "Warranty" },
        { key: "invno", label: "Invoice" },
        { key: "make", label: "Make" },
        { key: "pmodel", label: "Model" },
        { key: "ptype", label: "Type" },
        { key: "company", label: "Company" },
        { key: "location", label: "Location" },

      ]
    },
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom;
      this.dateTo = changedDateTo;
    },
    modalDateEvent(modal_id) {
      this.$bvModal.show(modal_id);
    },
    setLastMonth() {
      let fromDate = new Date();
      fromDate.setDate(fromDate.getDate() - 30);

      this.dateFrom = fromDate.toJSON().slice(0, 10);
      this.dateTo = new Date().toJSON().slice(0, 10);

      this.fetchData();
    },
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      this.setDefaultColumns();
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;
      params = {
        xml: "true",
        date_from: this.from(),
        date_to: this.to(),
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.$http
        .get("api/aoi/tables/alldata-shippedsearch.php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
    fetchData() {
      const currentRequestId = ++this.requestId;
      const productType = modelStore.selectedModel === 'All' ? '' : modelStore.selectedModel;

      let params = {};
      this.message = "";
      setIsFetching(true);
      this.loading = true;
      this.setDefaultColumns();
      params = {
        date_from: this.from(),
        date_to: this.to(),
        productType: productType,
        ...(modelStore.isSpaced ? { spaced: true} : {})
      };
      this.$http
        .get("api/aoi/tables/alldata-shippedsearch.php", { params })
        .then(
          res => {
            if (currentRequestId !== this.requestId) return;

            if (res.data.message) {
              setIsFetching(false);
              this.loading = false;
              this.message = res.data.message;
            }
            this.data = res.data.records.map(record => ({
              ...record,
              fnsid: record.fnsid || record.fnsId
            }));
            if (res.data.records && res.data.records.length) {
              this.total = res.data.records.length;
              res.data.records.forEach(obj => {
              });
              this.message = "";
            } else {
              this.total = 0;
            }
            setIsFetching(false);
            this.loading = false;
          }
        ).catch(err => {
          if (currentRequestId !== this.requestId) return;
          setIsFetching(false);
          this.loading = false;
          console.log(err);
        });
    },
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
      return this.dateFrom;
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
      return this.dateTo;
    }
  },
  mounted() {
    let fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() - 1);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();
  },
  computed: {
    selectedModel() {
      return modelStore.selectedModel;
    },
    flagChanged() {
      return modelStore.isSpaced;
    },
  },
  watch: {
    selectedModel() {
      this.fetchData();
    },
    flagChanged() {
      this.fetchData();
    },
  },
};
</script>
<style>
.complaintClass {
  width: 200px;
}
.download-button {
  width: 150px;
  margin: auto;
  margin-left: 10px;
  float: right;
  font-weight: 500;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.sk-double-bounce {
  display: inline-block;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  color: #ffffff68;
  padding-right: 0.5em;
}
.gm-style .gm-style-iw-d {
  color: black !important;
}
.gm-style .gm-style-iw-d span {
  font-size: 1.1em;
}
.gm-style .gm-style-iw-d b {
  font-size: 1.1em;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.vdp-datepicker .input-group input {
  background: #515b65 !important;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>




